// src/components/StarRating.jsx
import React from "react";

export default function StarRating({ score }) {
  // 100 = 5 stars, 80 = 4, etc. Allow partial stars
  const stars = Math.round((score / 100) * 5 * 2) / 2; // nearest 0.5
  return (
    <span className="ml-2 align-middle">
      {[1, 2, 3, 4, 5].map((i) => {
        if (stars >= i)
          return (
            <span key={i} className="text-yellow-400">
              ★
            </span>
          );
        if (stars >= i - 0.5)
          return (
            <span key={i} className="text-yellow-400">
              ☆
            </span>
          );
        return (
          <span key={i} className="text-gray-300">
            ★
          </span>
        );
      })}
    </span>
  );
}
